// extracted by css-extract-rspack-plugin
export default {"container":"Rxij4","documentArea":"m2niT","editorContent":"BXabs","img":"O0ie6"};